import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useAreaTypes = () => {
  return useSettingsQuery('upmAllAreaTypes', [], {
    gcTime: 0,
    retry: false,
    staleTime: 0
  })
}

export const QueryKey = 'upmAllAreaTypes'
